import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/plugins/i18n.js'

// 导入全局 CSS
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'

// 导入插件
import '@/plugins/axios'
import '@/plugins/i18n.js'
import '@/plugins/vue-swiper.js'
import '@/plugins/element-ui'
import '@/plugins/utils.js'
import '@/plugins/vue-clipboard.js'
import '@/plugins/filter.js'
import '@/plugins/component.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
